export type LoaderMode = 'determinate' | 'indeterminate';

export class LoaderShow {
  static readonly type = '[Loader] Show';

  constructor(public mode: LoaderMode) {
  }
}

export class LoaderProgress {
  static readonly type = '[Loader] Progress';

  constructor(public value: number) {
  }
}

export class LoaderHide {
  static readonly type = '[Loader] Hide';

  constructor() {
  }
}
